import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7115f6b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7115f6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115f6b2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/rightbar/index.vue
// module id = null
// module chunks = 